import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./css/IIITHWriteUpOne.css";

const IIITHWriteupOne = () => {
  return (
    <div className="accordion-wrapper intern-bg">
      <h1 className="heading-text-3">About IIITH_prep</h1>

      <div className="accordion-card">
        <Typography className="intro-text">
          We at <b>IIITH_prep</b> provide full guidance to crack{" "}
          <b>LEEE and PGEE</b> exam in the Electronics and Communication
          Engineering domain. Our precisely curated test series and structured
          interview preparation sessions are the backbone of excellence.
        </Typography>

        <Accordion className="custom-accordion" style={{ marginTop: "20px" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">IIITH_prep Team</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul className="about-list">
              <li>
                <b>Ishan Agarwal:</b> Our founder and passionate guy in the
                field of electronics, he currently working as Analog Design
                Engineer in Sophrosyne Semiconductors. He himself cleared both
                LEEE and PGEE in Electronics domain. He will taking your
                interview sessions.
              </li>
              <li>
                <b>Varun and Vedant:</b> Guys who will be responsible for taking
                care of your technical problem whether you are not able to login
                or unable to access the meet, scheduling your interview sessions
                etc.
              </li>
              <li>
                <b>Shreyansh:</b> Person who will take discussion on each test
                paper as scheduled.
              </li>
              <li>
                <b>Shishir:</b> Our co-founder and who deals with all the
                management related stuffs.
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>

        <Accordion className="custom-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Categories</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <p>We have provided all possible flexibilities, like:</p>
            <ul className="about-list">
              <li>You can take only the Test Series</li>
              <li>You can take only Interview Sessions</li>
              <li>You can avail both Test Series and Interview Sessions</li>
            </ul>
          </AccordionDetails>
        </Accordion>

        <Accordion className="custom-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Registration Fees</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul className="about-list">
              <li>
                LEEE Test Series: <b>₹799</b>
              </li>
              <li>
                LEEE Interview Prep: <b>₹1599</b>
              </li>
              <li>
                LEEE Test Series and Interview Prep: <b>₹1899</b>
              </li>
              <li>
                PGEE Test Series: <b>₹999</b>
              </li>
              <li>
                PGEE Interview Prep: <b>₹1499</b>
              </li>
              <li>
                PGEE Test Series and Interview Prep: <b>₹1999</b>
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>

        <Accordion className="custom-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Terms and Conditions</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul className="about-list">
              <li>
                Access credentials for test series and interview sessions are{" "}
                <b>non-transferable</b> and intended for individual use only.
              </li>
              <li>
                IIITH_prep reserves the right to reschedule or modify the test
                series/interview sessions in case of unavoidable circumstances.
              </li>
              <li>
                Participants must ensure they have a stable internet connection
                for smooth conduct of online sessions.
              </li>
              <li>
                By registering, you agree to follow the code of conduct during
                discussions, tests, and interviews.
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default IIITHWriteupOne;
